<div class="flex flex-col space-y-xxs">
  <button
    mat-flat-button
    class="dialog-confirm"
    color="primary"
    (click)="credentialLoginSelected()"
    data-pgr-id="btnGoToCredentialLogin"
  >
    Login with Credentials
    <mat-icon data-pgr-id="iconChevron" iconPositionEnd>
      chevron_right
    </mat-icon>
  </button>

  <button
    mat-flat-button
    class="dialog-confirm"
    color="primary"
    (click)="ssoLoginSelected()"
    data-pgr-id="btnGoToSsoLogin"
  >
    Login with SSO
    <mat-icon data-pgr-id="iconChevron" iconPositionEnd>
      chevron_right
    </mat-icon>
  </button>

  <button
    mat-flat-button
    class="dialog-confirm"
    color="primary"
    (click)="mfaConfigSelected()"
    data-pgr-id="btnGoToMfaConfig"
  >
    Configure MFA
    <mat-icon data-pgr-id="iconChevron" iconPositionEnd>
      chevron_right
    </mat-icon>
  </button>
</div>
